import { createSimpleRequest } from '@/business/apiTreatment/request/reusableBaseRequest';

/**
 * Business function. make query params function for simple API call.
 * @param {array} searchAttributesArray the attributes to search in
 * @param limit
 * @param {boolean} useEntities
 * @returns {function({search?: *, entities?: *, idx: *}): ({q: {$or: *}})} The makeQueryParams function.
 */
const createTechnicianSimpleRequest = ({
  searchAttributesArray,
  limitItemsRequest,
  useEntities,
  idField,
}) => ({ search, entities, idx }) => {
  const queryParams = createSimpleRequest({
    searchAttributesArray,
    limitItemsRequest,
    useEntities,
    idField,
  })({ search, entities, idx });
  if (queryParams.q && queryParams.q.$and) {
    queryParams.q.$and.push({
      $or: [
        {
          end_date: {
            $gte: { $date: new Date().toISOString() },
          },
        },
        {
          end_date: { $null: null },
        },
        {
          end_date: {
            $lte: { $date: '1000-01-01T00:00:00.000Z' },
          },
        },
      ],
    });
  }
  return queryParams;
};
export default createTechnicianSimpleRequest;
